<template>
  <div>
    <navlist :navlist="about" />

    <router-view />
  </div>
</template>

<script>
import navlist from "../components/nav";
export default {
  components: {
    navlist
  },
  data() {
    return {
      about: [
        {
          path: "/party/member",
          name: "在册党员"
        },
        {
          path: "/party/grid",
          name: "红色网格"
        },
        {
          path: "/party/activity",
          name: "主题党日活动"
        },
        {
          path: "/party/platform",
          name: "党员学习平台"
        }
      ]
    };
  }
};
</script>

<style>
</style>